export default "__VITE_ASSET__BbMQAVua__"